import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import PageBanner from "../../components/PageBanner";
import assetUrl from "../../services/assetUrl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaCalendarAlt, FaFileAlt, FaChevronLeft, FaChevronRight, FaArrowRight, FaMapMarkerAlt, FaLinkedinIn, FaQuoteLeft } from "react-icons/fa";

import { getAboutData } from "../../services/data.service"; // Backend Service
import Reveal from "../home/Reveal";
import "../home/homeRedesign.css";
import "./aboutNew.css";

const sp = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.9, strokeLinecap: "round", strokeLinejoin: "round" };
const STAT_ICONS = {
  alumni: (<svg {...sp}><circle cx="9" cy="8" r="3.1" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M16 6.2a3 3 0 0 1 0 5.6" /><path d="M17 14.4A5.5 5.5 0 0 1 20.5 19" /></svg>),
  handshake: (<svg {...sp}><path d="m11 17 2 2a1.5 1.5 0 0 0 2.1-2.1M13 15l2 2a1.5 1.5 0 0 0 2.1-2.1L13 10.5" /><path d="m18 14 2.5-2.5a2 2 0 0 0 0-2.8L17 5l-3 1" /><path d="M3.5 8.7 7 5l4 2-3 3a1.6 1.6 0 0 1-2.3 0l-.2-.2a1.6 1.6 0 0 1 0-2.3" /><path d="m9 19-2 2" /></svg>),
  bulb: (<svg {...sp}><path d="M9 18h6M10 21h4" /><path d="M12 3a6 6 0 0 0-4 10.5c.8.8 1 1.3 1 2.5h6c0-1.2.2-1.7 1-2.5A6 6 0 0 0 12 3Z" /></svg>),
  cap: (<svg {...sp}><path d="M22 10 12 5 2 10l10 5 10-5z" /><path d="M6 12v5c0 1 2.7 2 6 2s6-1 6-2v-5" /></svg>),
};
const IconTelescope = (<svg {...sp}><path d="m11 15-3.5 5.5M14 14l2 6" /><path d="m4 11 14-7 2 4-14 7z" /><path d="m9 8 2 4" /><circle cx="11.5" cy="14" r="1.6" /></svg>);
const IconFlag = (<svg {...sp}><path d="M3 19.5h18" /><path d="m5 19.5 4.2-7.6 3.1 5.1" /><path d="m10.6 19.5 4.1-7.1 4.6 7.1" /><path d="M14.7 12.4V4.6" /><path d="M14.7 4.6 19 6 14.7 7.7Z" /></svg>);
const LEGACY_ICONS = {
  quality: (<svg {...sp}><path d="M12 3 4 6v5c0 4.5 3.2 7.8 8 9 4.8-1.2 8-4.5 8-9V6l-8-3Z" /><path d="m9 12 2 2 4-4" /></svg>),
  industry: (<svg {...sp}><rect x="3" y="7.5" width="18" height="12" rx="2" /><path d="M8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5" /><path d="M3 12h18" /></svg>),
  values: (<svg {...sp}><path d="M12 21s-7-4.3-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.7-7 10-7 10Z" /></svg>),
};

const SectionHead = ({ eyebrow, heading, sub, center = true }) => (
  <div className={`abt-head${center ? " abt-head--center" : ""}`}>
    {eyebrow && <span className="eyebrow-ed">{eyebrow}</span>}
    <h2 className="heading-ed">{heading}</h2>
    {sub && <p className="abt-head__sub">{sub}</p>}
  </div>
);

const initials = (name = "") => {
  const w = name.replace(/^(Dr|Sri|Smt|Mr|Mrs|Ms|Prof)\.?\s+/i, "").trim().split(/\s+/);
  return ((w[0]?.[0] || "") + (w[1]?.[0] || "")).toUpperCase() || "A";
};
const splitName = (full = "") => {
  const i = full.indexOf(",");
  if (i === -1) return { name: full.trim(), desig: "" };
  return { name: full.slice(0, i).trim(), desig: full.slice(i + 1).trim() };
};

const AboutNagarjuna = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  // States for interactive components
  const [activeTab, setActiveTab] = useState(null);
  const [showAllCouncil, setShowAllCouncil] = useState(false);
  const COUNCIL_INITIAL = 6;
  const [activeCampus, setActiveCampus] = useState(0);
  const [activeMgmt, setActiveMgmt] = useState(0);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await getAboutData();
        if (res && res.success && res.data) {
          setAboutData(res.data);
          // Set initial active tab for councils if data exists
          if (res.data.governance_councils?.length > 0) {
            setActiveTab(res.data.governance_councils[0]._id || res.data.governance_councils[0].title);
          }
        }
      } catch (err) {
        console.error("Failed to load about data", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAbout();

    if (window.location.hash) {
      setTimeout(() => {
        const el = document.querySelector(window.location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 350);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => { setShowAllCouncil(false); }, [activeTab]);

  if (loading) return <div className="p-10 text-center" style={{ padding: '100px 0', fontSize: '1.2rem' }}>Loading Information...</div>;
  if (!aboutData) return <div className="p-10 text-center" style={{ padding: '100px 0', fontSize: '1.2rem' }}>Failed to load data. Please make sure the backend is running.</div>;

  const { badges, legacy, ncet_legacy, ngi_impact, leadership, impact, purpose, principal_message, governance_councils, governance_minutes, academic_council_minutes, campuses, campusIntro } = aboutData;

  const NCET_LEGACY_DEFAULT = {
    eyebrow: "OUR LEGACY",
    title_top: "Nagarjuna",
    title_bottom: "College of Engineering & Technology",
    description: "Nagarjuna College of Engineering and Technology (NCET), established in 2001 under the aegis of Nagarjuna Education Society, is an autonomous college affiliated to Visvesvaraya Technological University (VTU), Belagavi, recognised by the Government of Karnataka (GOK), approved by AICTE, New Delhi and accredited with NAAC A+ Grade. We nurture curiosity, cultivate talent, and empower students to become future-ready leaders and innovators.",
    image_url: "/images/about-nagarjuna/campus-1.png",
    badge_num: "25",
    badge_text: "Years of Academic Excellence",
    features: [
      { label: "Quality Education", icon: "quality" },
      { label: "Industry Relevant", icon: "industry" },
      { label: "Values & Integrity", icon: "values" }
    ]
  };

  const NGI_DEFAULT_STATS = [
    { end_value: 30000, suffix: "+", label: "Happy Alumni", icon: "alumni" },
    { end_value: 500, suffix: "+", label: "Faculty", icon: "handshake" },
    { end_value: 7, suffix: "", label: "Institution Colleges", icon: "bulb" },
    { end_value: 30, suffix: "+ Years", label: "Years of Legacy", icon: "cap" }
  ];

  // "Our Campuses" intro column — admin-editable, with the original copy as fallback.
  const CAMPUS_INTRO_DEFAULTS = {
    eyebrow: "Our Campuses",
    heading: "The Nagarjuna Family of Institutions",
    location: "Bengaluru, Karnataka",
    text: "Nagarjuna College of Engineering and Technology (NCET), the top engineering college in Bangalore, started in the year 2001 under the aegis of Nagarjuna Education Society.",
    ctaLabel: "Explore Campuses",
    ctaLink: "https://ncet.co.in/",
  };
  const ci = { ...CAMPUS_INTRO_DEFAULTS };
  if (campusIntro) {
    Object.keys(CAMPUS_INTRO_DEFAULTS).forEach((k) => {
      if (campusIntro[k]) ci[k] = campusIntro[k];
    });
  }

  // Derive variables for components
  const activeCouncil = governance_councils?.find(c => (c._id || c.title) === activeTab) || governance_councils?.[0] || { members: [] };
  const activeMembers = activeCouncil.members || [];
  const councilShown = showAllCouncil ? activeMembers : activeMembers.slice(0, COUNCIL_INITIAL);
  const campus = campuses?.[activeCampus] || campuses?.[0];

  // Helper function to safely format dates
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateStr).toLocaleDateString('en-GB', options).replace(/\//g, '-');
  };

  return (
    <div className="abt-page">
      <Header parentMenu="about" topbarEnable="enable" />

      {/* ---- Hero ---- */}
      <PageBanner
        title="About NCET"
        eyebrow="Nagarjuna College of Engineering & Technology"
        subtitle="A legacy of academic excellence, innovation, and holistic development shaping the engineers and leaders of tomorrow."
      />

      {/* ---- Our Legacy ---- */}
      <section className="abt-legacy" id="legacy">
        <span className="abt-legacy__accent" aria-hidden="true" />
        <span className="abt-legacy__dots" aria-hidden="true" />
        <div className="container">
          <div className="abt-legacy__grid">
            <Reveal className="abt-legacy__content">
              <span className="abt-legacy__eyebrow">Our Legacy</span>
              <h1 className="abt-legacy__title">
                <span className="abt-legacy__title-top">Nagarjuna</span>
                <span className="abt-legacy__title-bottom">Group of Institutions</span>
              </h1>
              <p className="abt-legacy__desc">{legacy?.description}</p>
              <ul className="abt-legacy__features">
                {legacy?.features && legacy.features.map((f, i) => (
                  <li className="abt-legacy__feature" key={i}>
                    <span className="abt-legacy__feature-ic">{LEGACY_ICONS[f.icon] || LEGACY_ICONS['quality']}</span>
                    {f.label}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal className="abt-legacy__media">
              <div className="abt-legacy__frame"><img src={assetUrl(legacy?.image_url)} alt="Legacy" /></div>
              <div className="abt-legacy__badge">
                <span className="abt-legacy__badge-num">25</span>
                <span className="abt-legacy__badge-text">Years of Academic Excellence</span>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ---- NGI Legacy Section (Impact) ---- */}
      <section className="abt-impact abt-impact--ngi">
        <div className="container">
          <div className="abt-impact__grid">
            <Reveal className="abt-impact__intro">
              <span className="abt-impact__eyebrow">{ngi_impact?.eyebrow || "OUR IMPACT"}</span>
              <h2 className="abt-impact__title">{ngi_impact?.title || "Nagarjuna Group of Institutions (NGI)"}</h2>
              <p className="abt-impact__text">
                {ngi_impact?.description || "Nagarjuna Group of Institutions (NGI) empowers aspiring minds with quality education, fostering innovation, excellence, and holistic growth for a successful future."}
              </p>
            </Reveal>
            <div className="abt-impact__stats">
              {(ngi_impact?.stats && ngi_impact.stats.length > 0
                ? ngi_impact.stats
                : NGI_DEFAULT_STATS
              ).map((s, i) => (
                <div className="abt-impact__stat" key={i}>
                  <span className="abt-impact__stat-ic">{STAT_ICONS[s.icon] || STAT_ICONS['alumni']}</span>
                  <span className="abt-impact__stat-num">
                    <CountUp end={Number(s.end_value) || 0} separator="," duration={2.2} enableScrollSpy scrollSpyOnce />
                    {s.suffix && <i>{s.suffix}</i>}
                  </span>
                  <span className="abt-impact__stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ---- Management Desk ---- */}
      <section className="abt-sec abt-mg-sec" id="management">
        <div className="container">
          <Reveal><SectionHead center={false} eyebrow={leadership?.heading} heading="From the Management Desk" sub={leadership?.subheading} /></Reveal>
          <Reveal>
            <div className="abt-mg__row" onMouseLeave={() => setActiveMgmt(0)}>
              {leadership?.cards && leadership.cards.map((c, idx) => {
                const active = idx === activeMgmt;
                return (
                  <article
                    key={c.name}
                    className={`abt-mg2${active ? " is-active" : ""}`}
                    onMouseEnter={() => setActiveMgmt(idx)}
                    onFocus={() => setActiveMgmt(idx)}
                    tabIndex={0}
                  >
                    <div className="abt-mg2__photo">
                      <img src={assetUrl(c.image_url)} alt={c.name} />
                      <div className="abt-mg2__overlay">
                        <h3 className="abt-mg2__name">{c.name}</h3>
                        <span className="abt-mg2__role">{c.role}</span>
                      </div>
                    </div>
                    <div className="abt-mg2__panel">
                      <div className="abt-mg2__panel-inner">
                        <span className="abt-mg2__qmark" aria-hidden="true"><FaQuoteLeft /></span>
                        <p className="abt-mg2__quote">{c.description}</p>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---- Campuses ---- */}
      <section className="abt-sec abt-cp-sec" id="campuses">
        <div className="container">
          <div className="abt-cp__grid">
            <Reveal className="abt-cp__intro">
              <span className="eyebrow-ed">{ci.eyebrow}</span>
              <h2 className="heading-ed">{campus?.name || ci.heading}</h2>
              {(campus?.location || ci.location) && <span className="abt-cp__loc"><FaMapMarkerAlt /> {campus?.location || ci.location}</span>}
              {((campus && typeof campus.description === 'string' ? campus.description : ci.text)) && (
                  <p className="abt-cp__text">{campus && typeof campus.description === 'string' ? campus.description : ci.text}</p>
              )}
              {ci.ctaLabel && (
                <a href={campus?.link || ci.ctaLink || "#"} className="abt-cp__cta" target="_blank" rel="noopener noreferrer">
                  {ci.ctaLabel} <FaArrowRight />
                </a>
              )}
            </Reveal>

            {campus && (
              <Reveal className="abt-cp__showcase">
                <div className="abt-cp__feature">
                  <div className="abt-cp__feature-media"><img src={assetUrl(campus.image_url)} alt={campus.name} /></div>
                  <div className="abt-cp__feature-body">
                    <h3 className="abt-cp__feature-name">{campus.name}</h3>
                    <span className="abt-cp__feature-loc"><FaMapMarkerAlt /> {campus.location}, Karnataka</span>
                    <a className="abt-cp__feature-link" href={campus.link} target="_blank" rel="noopener noreferrer">Visit Website <FaArrowRight /></a>
                  </div>
                </div>
                <div className="abt-cp__thumbs">
                  {campuses && campuses.map((c, i) => (
                    <button type="button" key={i} className={`abt-cp__thumb${activeCampus === i ? " is-active" : ""}`} onClick={() => setActiveCampus(i)} aria-label={c.name}>
                      <img src={assetUrl(c.image_url)} alt={c.name} />
                    </button>
                  ))}
                </div>
              </Reveal>
            )}
          </div>
        </div>
      </section>

      {/* ---- NCET Legacy Section ---- */}
      <section className="abt-legacy abt-legacy--ncet" id="ncet-legacy">
        <span className="abt-legacy__accent" aria-hidden="true" />
        <span className="abt-legacy__dots" aria-hidden="true" />
        <div className="container">
          <div className="abt-legacy__grid">
            <Reveal className="abt-legacy__content">
              <span className="abt-legacy__eyebrow">{ncet_legacy?.eyebrow || NCET_LEGACY_DEFAULT.eyebrow}</span>
              <h2 className="abt-legacy__title">
                <span className="abt-legacy__title-top">{ncet_legacy?.title_top || NCET_LEGACY_DEFAULT.title_top}</span>
                <span className="abt-legacy__title-bottom">{ncet_legacy?.title_bottom || NCET_LEGACY_DEFAULT.title_bottom}</span>
              </h2>
              <p className="abt-legacy__desc" style={{ textAlign: "justify" }}>
                {ncet_legacy?.description || NCET_LEGACY_DEFAULT.description}
              </p>
              <ul className="abt-legacy__features">
                {(ncet_legacy?.features && ncet_legacy.features.length > 0 ? ncet_legacy.features : NCET_LEGACY_DEFAULT.features).map((f, i) => (
                  <li className="abt-legacy__feature" key={i}>
                    <span className="abt-legacy__feature-ic">{LEGACY_ICONS[f.icon] || LEGACY_ICONS['quality']}</span>
                    {f.label}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal className="abt-legacy__media">
              <div className="abt-legacy__frame"><img src={assetUrl(ncet_legacy?.image_url || NCET_LEGACY_DEFAULT.image_url)} alt="NCET Legacy" /></div>
              <div className="abt-legacy__badge">
                <span className="abt-legacy__badge-num">{ncet_legacy?.badge_num || NCET_LEGACY_DEFAULT.badge_num}</span>
                <span className="abt-legacy__badge-text">{ncet_legacy?.badge_text || NCET_LEGACY_DEFAULT.badge_text}</span>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ---- Our Impact ---- */}
      <section className="abt-impact">
        <div className="container">
          <div className="abt-impact__grid">
            <Reveal className="abt-impact__intro">
              <span className="abt-impact__eyebrow">{impact?.eyebrow || "Our Impact"}</span>
              <h2 className="abt-impact__title">{impact?.title}</h2>
              <p className="abt-impact__text">{impact?.description}</p>
            </Reveal>
            <div className="abt-impact__stats">
              {(impact?.stats && impact.stats.length > 0 ? impact.stats : NGI_DEFAULT_STATS).map((s, i) => (
                <div className="abt-impact__stat" key={i}>
                  <span className="abt-impact__stat-ic">{STAT_ICONS[s.icon] || STAT_ICONS['alumni']}</span>
                  <span className="abt-impact__stat-num">
                    <CountUp end={Number(s.end_value) || 0} separator="," duration={2.2} enableScrollSpy scrollSpyOnce />
                    {s.suffix && <i>{s.suffix}</i>}
                  </span>
                  <span className="abt-impact__stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ---- Vision & Mission + Principal ---- */}
      <section className="abt-sec abt-vm-sec" id="vision-mission">
        <div className="container">
          <Reveal><SectionHead eyebrow="Our Purpose" heading="Vision & Mission" /></Reveal>
          <Reveal>
            <div className="abt-vm__grid">
              <div className="abt-vm__card abt-vm__card--vision">
                <span className="abt-vm__icon">{IconTelescope}</span>
                <div className="abt-vm__body">
                  <h3 className="abt-vm__title">Vision</h3>
                  <p className="abt-vm__text">{purpose?.vision}</p>
                </div>
              </div>
              <div className="abt-vm__card abt-vm__card--mission">
                <span className="abt-vm__icon">{IconFlag}</span>
                <div className="abt-vm__body">
                  <h3 className="abt-vm__title">Mission</h3>
                  <p className="abt-vm__text">{purpose?.mission}</p>
                </div>
              </div>
            </div>
          </Reveal>
          <Reveal>
            <div className="abt-pr" id="principal">
              <div className="abt-pr__media"><img src={assetUrl(principal_message?.image_url)} alt={principal_message?.name} /></div>
              <div className="abt-pr__body">
                <span className="abt-pr__eyebrow">Principal's Message</span>
                <span className="abt-pr__quote-mark"><FaQuoteLeft /></span>
                {principal_message?.message?.split('\n').map((paragraph, idx) => (
                  paragraph.trim() ? <p key={idx} className="abt-pr__text">{paragraph}</p> : <br key={idx} />
                ))}
                <p className="abt-pr__sign">— {principal_message?.name}<span>Principal, NCET</span></p>
              </div>
              <span className="abt-pr__dots" aria-hidden="true" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---- Institutional Councils ---- */}
      <section className="abt-sec abt-co-sec">
        <div className="container">
          <Reveal><SectionHead eyebrow="Governance" heading="Institutional Councils" /></Reveal>
          <Reveal>
            <div className="abt-co__tabs" role="tablist">
              {governance_councils && governance_councils.map((t) => (
                <button key={t._id || t.title} type="button" role="tab" aria-selected={activeTab === (t._id || t.title)} className={`abt-co__tab${activeTab === (t._id || t.title) ? " is-active" : ""}`} onClick={() => setActiveTab(t._id || t.title)}>
                  {t.title}
                </button>
              ))}
            </div>
          </Reveal>
          <Reveal>
            <div className="abt-co__grid">
              {councilShown.map((m, i) => {
                const { name, desig } = splitName(m.name);
                return (
                  <div className="abt-co-card" key={i}>
                    <span className="abt-co-card__avatar">{initials(name)}</span>
                    <div className="abt-co-card__body">
                      <h4 className="abt-co-card__name">{name}</h4>
                      {desig && <p className="abt-co-card__desig">{desig}</p>}
                    </div>
                    <span className="abt-co-card__role">{m.role}</span>
                  </div>
                );
              })}
            </div>
            {activeMembers.length > COUNCIL_INITIAL && (
              <div className="abt-co__more">
                <button type="button" className="abt-co__more-btn" onClick={() => setShowAllCouncil((v) => !v)}>
                  {showAllCouncil ? "Show Less" : "View All Members"} <FaArrowRight />
                </button>
              </div>
            )}
          </Reveal>
        </div>
      </section>

      {/* ---- Meeting Minutes ---- */}
      <section className="abt-sec abt-min-sec">
        <div className="container">
          <div className="abt-min__head">
            <div>
              <span className="eyebrow-ed">Governance</span>
              <h2 className="heading-ed" style={{ margin: 0 }}>MoM Governing Body</h2>
            </div>
            <div className="abt-min__nav">
              <button className="abt-min-prev" aria-label="Previous"><FaChevronLeft /></button>
              <button className="abt-min-next" aria-label="Next"><FaChevronRight /></button>
            </div>
          </div>
          {Array.isArray(governance_minutes) && governance_minutes.length > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{ prevEl: ".abt-min-prev", nextEl: ".abt-min-next" }}
              breakpoints={{ 0: { slidesPerView: 1, spaceBetween: 18 }, 640: { slidesPerView: 2, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 22 } }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
            >
              {governance_minutes.map((m, i) => (
                <SwiperSlide key={i} style={{ height: "auto" }}>
                  <a href={assetUrl(m.pdf_url)} target="_blank" rel="noopener noreferrer" className="abt-min-card">
                    <span className="abt-min-card__top">
                      <span className="abt-min-card__icon"><FaFileAlt /></span>
                      <span className="abt-min-card__date"><FaCalendarAlt /> {formatDate(m.date)}</span>
                    </span>
                    <h3 className="abt-min-card__title">{m.title}</h3>
                    <span className="abt-min-card__link">View Document <FaArrowRight /></span>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </section>

      {/* ---- Academic Council Minutes ---- */}
      <section className="abt-sec abt-min-sec" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="abt-min__head">
            <div>
              <span className="eyebrow-ed">Academics</span>
              <h2 className="heading-ed" style={{ margin: 0 }}>MoM Academic Council</h2>
            </div>
            <div className="abt-min__nav">
              <button className="abt-ac-prev" aria-label="Previous"><FaChevronLeft /></button>
              <button className="abt-ac-next" aria-label="Next"><FaChevronRight /></button>
            </div>
          </div>
          {Array.isArray(academic_council_minutes) && academic_council_minutes.length > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{ prevEl: ".abt-ac-prev", nextEl: ".abt-ac-next" }}
              breakpoints={{ 0: { slidesPerView: 1, spaceBetween: 18 }, 640: { slidesPerView: 2, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 22 } }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
            >
              {academic_council_minutes.map((m, i) => (
                <SwiperSlide key={i} style={{ height: "auto" }}>
                  <a href={assetUrl(m.pdf_url)} target="_blank" rel="noopener noreferrer" className="abt-min-card">
                    <span className="abt-min-card__top">
                      <span className="abt-min-card__icon"><FaFileAlt /></span>
                      <span className="abt-min-card__date"><FaCalendarAlt /> {formatDate(m.date)}</span>
                    </span>
                    <h3 className="abt-min-card__title">{m.title}</h3>
                    <span className="abt-min-card__link">View Document <FaArrowRight /></span>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutNagarjuna;
